import { AppConfig } from '@sgi/af-shell-shared';

export let CONFIG: AppConfig | null = null;

export const assignConfig = (newConfig: AppConfig) => {
  CONFIG = newConfig;
};
